// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13QTo","input":"styles_input__3f7p6"};